import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteAction } from '@stores/site/action';
import type { UserAction } from '@stores/user/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import updateImageListSrc from '@utils/update-image-list-src';
import { px2rem } from '@utils/px2rem';

interface CarnivalH5PageProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteAction;
    user?: UserAction;
    carnivalDetail?: any;
    handleImageClick: (item: any) => void;
}

@inject('app', 'site', 'user')
@observer
class CarnivalH5Page extends BasePage<CarnivalH5PageProps> {
    previousHeaderStatus = true;
    previousAppDownloadStatus = true;

    componentDidMount() {
        const { site, carnivalDetail } = this.props;
        // Header 和 App 下载入口均由活动的 showHeader 配置控制
        if (site) {
            this.previousHeaderStatus = site.getShowHeader();
            this.previousAppDownloadStatus = site.getAppDownloadShowStatus();
            const showHeader = carnivalDetail?.showHeader === true;
            site.setShowHeader(showHeader);
            site.setAppDownloadShowStatus(showHeader);
        }
        super.componentDidMount();
    }

    componentDidUpdate(prevProps: CarnivalH5PageProps) {
        const { site, carnivalDetail } = this.props;
        if (site && prevProps.carnivalDetail?.showHeader !== carnivalDetail?.showHeader) {
            const showHeader = carnivalDetail?.showHeader === true;
            site.setShowHeader(showHeader);
            site.setAppDownloadShowStatus(showHeader);
        }
    }

    componentWillUnmount() {
        const { site } = this.props;
        if (site) {
            site.setShowHeader(this.previousHeaderStatus);
            site.setAppDownloadShowStatus(this.previousAppDownloadStatus);
        }
    }

    // 点击图片跳转（配置了 pcUrl 时）
    render() {
        const { site, carnivalDetail, handleImageClick } = this.props;
        // 按接口返回顺序展示图片列表
        const images = carnivalDetail?.images || [];
        const showHeader = carnivalDetail?.showHeader === true;
        const wrapperPaddingTop = showHeader
            ? px2rem(site?.appDownloadShowStatus ? 176 : 88)
            : 0;

        return (
            <div className={styles.wrapper}>
                {images.map((item: any) => (
                    <img
                        key={item.id}
                        src={updateImageListSrc(item.image, 16)}
                        alt=""
                        className={`${styles.image} ${item.pcUrl ? styles.clickable : ''}`}
                        onClick={() => handleImageClick(item)}
                    />
                ))}
            </div>
        );
    }
}

export default withRouter(CarnivalH5Page);
